/* Paws Imperial — навигация: ссылки на кнопках + бургер-меню.
   Работает поверх экспорта pen.dev, ориентируясь на data-pencil-name и текст. */
(function () {
  'use strict';

  var BOOK = '/pages/book';

  /* Кнопки/CTA — сопоставление по видимому тексту (UPPERCASE, схлопнутые пробелы) */
  var LBL = {
    /* 28.10.2026 слово Billionaire: Free Trial убран, кнопки «BOOK A DAY» — анкета на одном дне */
    'BOOK A DAY': BOOK + '?plan=single',
    'BOOK A DAY LIKE THIS': BOOK,
    'BOOK A PICKUP AT YOUR DOOR': BOOK,
    'BOOK HER FIRST TRIP': BOOK,
    'BOOK HER FIRST DAY OUT': BOOK,
    'BOOK A SEAT FOR HER': BOOK,
    'BOOK NOW': BOOK,
    'BOOK IT': BOOK,
    'BOOK A VIDEO WALKTHROUGH': BOOK,
    /* Страница /pages/the-day снята с публикации, поэтому кнопка первого экрана
       ведёт не на неё, а на блок «06 The Day Sheet» здесь же, на главной.
       Точный якорь проставляет dayAnchor(): у десктопной и мобильной вёрстки
       он свой, потому что оба холста лежат в DOM одновременно. */
    'SEE HOW A DAY RUNS': '#pi-day',
    /* Первый экран (12.09.2026): вторая кнопка — на тарифы, третья — на шаттл.
       Якоря проставляет dayAnchor(), для телефона свои (-m).
       14.09.2026 подписи укорочены: без «SEE». По тексту ищутся только кнопки
       (имена «Button…»/«…CTA»), пункты меню и подвала с тем же текстом не задеваются. */
    'PLANS & PRICING': '#pi-plans',
    'THE SHUTTLE': '#pi-shuttle',
    /* Кнопки тарифов ведут прямо на анкету, а не на страницу тарифов.
       Раньше человек с главной попадал на /pages/plans, где видел те же
       четыре карточки, и только оттуда — на анкету. Лишний шаг между
       намерением и заявкой: цену он уже увидел на главной. */
    /* Разовая поездка. Раньше она была только строкой в мелком тексте
       («Single trips $195, returning clients only») — купить её было негде.
       Теперь это карточка тарифа, кнопка ведёт в ту же анкету. */
    /* 12.10.2026: кнопки пакетов — сразу на нужный пакет (?plan=), иначе форма открывалась на другом пакете */
    'BOOK A SINGLE DAY': BOOK + '?plan=single',
    'START WITH 7': BOOK + '?plan=7',
    'CHOOSE 14': BOOK + '?plan=14',
    'CHOOSE 30': BOOK + '?plan=30',
    'BOOK A PRIVATE DAY': BOOK + '?plan=private', // 29.10.2026: карточка Private Day на главной
    'JOIN THE CLUB': '/cart/51037481631991:1',
    'SEE THE WHOLE SHOP': '/collections/shop',
    'READ THE WHOLE STORY': '/pages/our-story',
    'FOLLOW THE BUILD': '/pages/resort',
    'ASK ON WHATSAPP': 'https://wa.me/19296310102',
    /* Тот же смысл, но полной фразой: так подписана кнопка в десктопном
       «18 Final CTA». Мобильная сборка короче — поэтому нужны обе формы. */
    'ASK A QUESTION ON WHATSAPP': 'https://wa.me/19296310102',
    'ASK A QUESTION': BOOK,
    'SEE PLANS': '/pages/plans',
    'SEE THE PLANS': '/pages/plans'
  };

  /* Навигация и футер — сопоставление по data-pencil-name */
  var NAME = {
    'Brand': '/',
    /* Ни одна колонка подвала не линкуется целиком — ни десктопная
       «Brand Column», ни мобильная «Brand Stack». Внутри них лежат иконки
       соцсетей и адрес почты, и ссылка на главную накрывала их собой.
       Домой в обоих подвалах ведёт сам логотип, «Wordmark Row».

       «Brand Column» целиком не линкуем: внутри неё лежит блок «Contact»
       с почтой, и ссылка на главную накрывала адрес — клик по почте уводил
       на главную вместо почтового клиента. Ровно та же причина, по которой
       не линкуется мобильная «Brand Stack». Домой ведёт сам логотип. */
    'Wordmark Row': '/',
    /* Десктопная шапка повторяет бургер: те же шесть пунктов в том же порядке.
       Имена совпадают с разметкой pi-01-header.liquid — правишь там, правь и тут. */
    'Nav — Service area': '/#pi-area',
    'Nav — Our story': '/pages/our-story',
    'Nav — Why us': '/pages/why-us',
    'Nav — Plans & pricing': '/pages/plans',
    'Nav — The club': '/pages/club',
    'Nav — Shop': '/collections/shop',
    /* «The day sheet» и «The shuttle» убраны: страницы сняты с публикации
       и спрятаны «на будущее», ссылка на них дала бы 404. Сами пункты подвала
       скрыты в pi-nav.css — вернуть можно там же и здесь. */
    'Link — Plans & pricing': '/pages/plans',
    'Link — Service area': '/#pi-area',
    'Link — The club': '/pages/club',
    /* В магазине четыре категории: Not Perfect (своё производство), наборы,
       мерч, еда. Прежние Collars & leads, Harnesses, Trail gear и Care убраны
       из подвала — их товары переложены в Merch, съедобное ушло в Food. */
    'Link — Not Perfect': '/collections/not-perfect',
    'Link — Gift boxes': '/collections/boxes',
    'Link — Gifts & Membership': '/products/gift-card', // 29.10.2026: в подвале «Gift cards», клуб — отдельной ссылкой The club
    'Link — Merch': '/collections/paws-merch',
    'Link — Food': '/collections/food',
    'Link — Our story': '/pages/our-story',
    /* Страница отзывов (21.09.2026): всё, что написано о нас на карточке Google,
       скопировано дословно. Пункт стоит в колонке «Company» подвала. */
    'Link — Reviews': '/pages/testimonials',
    'Link — FAQ': '/pages/faq',
    'Link — Smart Dogs Resort': '/pages/resort',
    /* блог в магазине заведён с handle «journal», не «news» */
  };

  /* Пункты бургер-меню. 16.10.2026 Billionaire: порядок как в шапке компьютера —
     сначала услуга (Plans & pricing), вторым Shop, третьим Why us (убеждает
     сомневающихся), потом The club и Smart Resort (ещё не продаётся); FAQ — только
     здесь, последним. Our story в меню нет (16.10): ведёт кнопка «READ THE WHOLE
     STORY» на Why us, блок на главной и ссылка внизу страницы. «Service area» убран: на главной есть кнопка «See our service
     area» и кнопки городов, а внизу каждой страницы — города. Прежний порядок
     (Сергей, 12 августа) заменён этим решением.
     «The day», «The shuttle» в меню нет: страницы открываются по кнопкам главной.
     Десктопная шапка — отдельная разметка (sections/pi-01-header.liquid). */
  var NAV = [
    ['Plans & pricing', '/pages/plans'],
    ['Gift cards', '/products/gift-card'], // 29.10.2026 Billionaire: подарочные карты отдельной вкладкой, как в шапке компьютера
    ['Shop', '/collections/shop'],
    ['Why us', '/pages/why-us'],
    ['The club', '/pages/club'],
    ['Smart Resort <span class="pi-soon">soon</span>', '/pages/resort'],
    ['FAQ', '/pages/faq'],
  ];

  function txt(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase();
  }

  function wrap(el, href) {
    if (!el || !href) return false;
    if (el.tagName === 'A' || el.closest('a')) return false;
    var a = document.createElement('a');
    a.setAttribute('href', href);
    a.setAttribute('data-pi-link', '1');
    if (/^https?:/.test(href)) {
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener');
    }
    a.style.textDecoration = 'none';
    a.style.color = 'inherit';
    a.style.display = 'contents';
    a.style.cursor = 'pointer';
    el.parentNode.insertBefore(a, el);
    a.appendChild(el);
    return true;
  }

  function linkify() {
    var n, els, i;

    /* по имени */
    for (n in NAME) {
      if (!Object.prototype.hasOwnProperty.call(NAME, n)) continue;
      els = document.querySelectorAll('[data-pencil-name="' + n.replace(/"/g, '\\"') + '"]');
      for (i = 0; i < els.length; i++) wrap(els[i], NAME[n]);
    }

    /* по тексту — кнопки и CTA.
       В экспорте три вида имён: «Button — …», «… CTA» и «CTA — …».
       Форма «… Button» сейчас нигде не встречается — единственный носитель,
       «Check Button» из блока зоны обслуживания, убран вместе с полем ZIP.
       Селектор её всё равно ловит: экспорт из pen.dev приносит имена как
       придётся, и терять кнопку из-за формы имени мы уже один раз умели. */
    els = document.querySelectorAll(
      '[data-pencil-name^="Button"],[data-pencil-name$="Button"],' +
      '[data-pencil-name^="CTA"],[data-pencil-name$="CTA"],[data-pencil-name="CTA"]'
    );
    for (i = 0; i < els.length; i++) {
      var el = els[i];
      var nm = el.getAttribute('data-pencil-name');
      if (nm === 'Buttons' || nm === 'Hero Buttons') continue;
      var href = LBL[txt(el)];
      if (href) wrap(el, href);
    }

    /* витрина: старые ссылки на страницу-описание и на весь каталог
       ведём в оформленную коллекцию /collections/shop */
    els = document.querySelectorAll('a[href="/pages/shop"],a[href="/collections/all"]');
    for (i = 0; i < els.length; i++) els[i].setAttribute('href', '/collections/shop');

    /* телефон */
    /* страница контактов закрыта — всё ведём в форму брони */
    els = document.querySelectorAll('a[href="/pages/contact"]');
    for (i = 0; i < els.length; i++) els[i].setAttribute('href', BOOK);
  }

  function menu() {
    if (document.getElementById('pi-mnav')) return;

    var burgers = [].slice.call(document.querySelectorAll('[data-pencil-name="Menu"]'));

    /* На внутренних страницах бургера в макете нет — добавляем свой в шапку */
    if (!burgers.length) {
      var heads = document.querySelectorAll('[data-pencil-name="Header"]');
      for (var k = 0; k < heads.length; k++) {
        var btn = document.createElement('button');
        btn.className = 'pi-burger';
        btn.type = 'button';
        btn.setAttribute('aria-label', 'Menu');
        btn.innerHTML = '<span></span><span></span><span></span>';
        heads[k].appendChild(btn);
        burgers.push(btn);
      }
    }
    if (!burgers.length) return;

    var p = document.createElement('div');
    p.id = 'pi-mnav';
    p.setAttribute('role', 'dialog');
    p.setAttribute('aria-label', 'Menu');

    /* Логотип сверху панели: лапа плюс словесный знак, всё вместе — ссылка
       домой, как в шапке. Лапа рисуется маской из --pi-paw (объявлена на :root
       в theme.liquid), отдельного файла картинки тут не нужно.
       Носитель маски — <span>, а не <div>: в базовых стилях темы живёт
       `div:empty{display:none}`, и пустой div с одним фоном молча пропадает —
       на этом уже дважды терялась лапа в подвале и в мобильной шапке. */
    var h = '<button id="pi-mnav-x" type="button" aria-label="Close">&#215;</button>' +
            '<a id="pi-mnav-brand" href="/">' +
              '<span class="pi-mnav-paw" aria-hidden="true"></span>' +
              '<span class="pi-mnav-word">PAWS IMP&Eacute;RIAL</span>' +
            '</a><nav>';
    for (var i = 0; i < NAV.length; i++) {
      h += '<a href="' + NAV[i][1] + '">' + NAV[i][0] + '</a>';
    }
    h += '</nav>' +
         '<a class="pi-mnav-cta" href="' + BOOK + '?plan=single">BOOK A DAY</a>' +
         '<a class="pi-mnav-tel" href="mailto:info@pawsimperial.com">info@pawsimperial.com</a>';
    p.innerHTML = h;
    document.body.appendChild(p);

    function close() {
      p.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
    function open(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      p.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }

    document.getElementById('pi-mnav-x').addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    for (var j = 0; j < burgers.length; j++) {
      var b = burgers[j];
      /* иконка — svg: оборачиваем в свою кнопку, чтобы кликабельной была она,
         а не вся шапка (после чистки телефона svg лежит прямо в шапке) */
      var t = b;
      if (b.tagName.toLowerCase() === 'svg' && b.parentNode) {
        var hit = document.createElement('span');
        hit.className = 'pi-burger-hit';
        b.parentNode.insertBefore(hit, b);
        hit.appendChild(b);
        t = hit;
      }
      t.style.cursor = 'pointer';
      t.setAttribute('role', 'button');
      t.setAttribute('aria-label', 'Open menu');
      t.addEventListener('click', open);
    }
  }


  /* ------------------------------
     Телефон со страниц убран: заявки принимаем формой и почтой.
     Чистим и разметку экспорта, и текстовые узлы с номером.
     ------------------------------ */
  var PHONE = /\(?\s*929\s*\)?[\s.-]*631[\s.-]*0102/;
  var MAIL = 'info@pawsimperial.com';

  function unwrap(el) {
    var p = el.parentNode;
    if (!p) return;
    while (el.firstChild) p.insertBefore(el.firstChild, el);
    p.removeChild(el);
  }

  function scrubPhone() {
    var i, els;

    /* в мобильной шапке телефон и бургер лежат в одной tel-ссылке — её распускаем */
    els = document.querySelectorAll('a[href^="tel:"]');
    for (i = els.length - 1; i >= 0; i--) unwrap(els[i]);

    els = document.querySelectorAll('[data-pencil-name="Phone"]');
    for (i = els.length - 1; i >= 0; i--) {
      if (els[i].parentNode) els[i].parentNode.removeChild(els[i]);
    }

    /* карточки и блоки, целиком посвящённые телефону */
    els = document.querySelectorAll('.pg-card');
    for (i = els.length - 1; i >= 0; i--) {
      var h = els[i].querySelector('h3');
      if (h && /^\s*phone\s*$/i.test(h.textContent) && els[i].parentNode) {
        els[i].parentNode.removeChild(els[i]);
      }
    }

    /* текстовые узлы с номером */
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var list = [], n;
    while ((n = walker.nextNode())) {
      if (!PHONE.test(n.nodeValue)) continue;
      /* Исключение: реквизиты Zelle в блоке поддержки стройки на /pages/resort.
         Там номер — способ перевести деньги, а не канал связи, и он должен
         остаться. Контейнер помечен data-pi-phone-ok; без этой проверки чистка
         съедала бы его вместе с телефонами по всему остальному сайту. */
      if (n.parentNode && n.parentNode.closest && n.parentNode.closest('[data-pi-phone-ok]')) continue;
      list.push(n);
    }

    for (i = 0; i < list.length; i++) {
      n = list[i];
      var t = n.nodeValue
        .replace(/if it is urgent,?\s*call[^.]*\./i, 'If it is urgent, write to ' + MAIL + '.')
        .replace(/call us on[^.]*\./i, 'Write to ' + MAIL + '.')
        .replace(PHONE, '')
        .replace(/\s{2,}/g, ' ')
        .replace(/^[\s.,;:·—–-]+/, '')
        .replace(/[\s·—–-]+$/, '');
      if (!t || /^[.,;:·—–\s-]*$/.test(t)) {
        var nx = n.nextSibling;
        if (nx && nx.nodeType === 1 && nx.tagName === 'BR' && nx.parentNode) nx.parentNode.removeChild(nx);
        var pv = n.previousSibling;
        if (pv && pv.nodeType === 1 && pv.tagName === 'BR' && pv.parentNode) pv.parentNode.removeChild(pv);
        if (n.parentNode) n.parentNode.removeChild(n);
      } else {
        n.nodeValue = t;
      }
    }
  }

  /* ------------------------------
     Соцсети в подвале. В экспорте на их месте стоит строка
     «Instagram · TikTok · YouTube» — заменяем её рядом иконок.
     Работает и в десктопном подвале, и в мобильном.
     ------------------------------ */
  var SOCIAL = [
    ['Instagram', 'https://www.instagram.com/pawsimperial',
      'M7.8 2h8.4A5.8 5.8 0 0 1 22 7.8v8.4A5.8 5.8 0 0 1 16.2 22H7.8A5.8 5.8 0 0 1 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2Zm0 1.9A3.9 3.9 0 0 0 3.9 7.8v8.4a3.9 3.9 0 0 0 3.9 3.9h8.4a3.9 3.9 0 0 0 3.9-3.9V7.8a3.9 3.9 0 0 0-3.9-3.9H7.8Zm4.2 2.9a5.2 5.2 0 1 1 0 10.4 5.2 5.2 0 0 1 0-10.4Zm0 1.9a3.3 3.3 0 1 0 0 6.6 3.3 3.3 0 0 0 0-6.6Zm5.5-2.6a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4Z'],
    ['TikTok', 'https://www.tiktok.com/@pawsimperial',
      'M16.5 2h-3v13.1a2.6 2.6 0 1 1-2.2-2.6v-3a5.6 5.6 0 1 0 5.2 5.6V9.4a7.4 7.4 0 0 0 4.3 1.4V7.8a4.5 4.5 0 0 1-4.3-4.5V2Z'],
    ['YouTube', 'https://www.youtube.com/@pawsimperial',
      'M21.6 7.2a2.5 2.5 0 0 0-1.8-1.8C18.2 5 12 5 12 5s-6.2 0-7.8.4A2.5 2.5 0 0 0 2.4 7.2 26 26 0 0 0 2 12a26 26 0 0 0 .4 4.8 2.5 2.5 0 0 0 1.8 1.8C5.8 19 12 19 12 19s6.2 0 7.8-.4a2.5 2.5 0 0 0 1.8-1.8A26 26 0 0 0 22 12a26 26 0 0 0-.4-4.8ZM10.1 15V9l5.2 3-5.2 3Z'],
    ['WhatsApp', 'https://wa.me/19296310102',
      'M12 2a9.9 9.9 0 0 0-8.5 15L2 22l5.2-1.4A9.9 9.9 0 1 0 12 2Zm0 1.9a8 8 0 0 1 6.5 12.7 8 8 0 0 1-10.9 2l-.4-.2-3 .8.8-2.9-.2-.4A8 8 0 0 1 12 3.9Zm-3.4 4c-.2 0-.5.1-.7.4-.3.3-.9.9-.9 2.1s.9 2.4 1 2.6c.1.2 1.7 2.7 4.2 3.7 2.1.8 2.5.7 3 .6.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2l-.6-.3-1.6-.8c-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.6 6.6 0 0 1-3.3-2.9c-.1-.2 0-.4.1-.5l.4-.5c.1-.2.2-.3.3-.5v-.5l-.8-1.9c-.2-.4-.4-.4-.6-.4h-.5Z']
  ];

  /* Почта кликается везде одинаково — открывает почтовый клиент.
     В экспорте адрес лежит просто текстом, без ссылки, поэтому обходим все
     конечные узлы и оборачиваем найденные адреса в mailto. Узлы, уже лежащие
     внутри ссылки, пропускаем: в мобильном подвале своя разметка со своим
     mailto, второй раз её трогать не нужно. */
  function mailLinks() {
    var els = document.querySelectorAll('body *');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.children.length) continue;
      if ((el.textContent || '').trim() !== MAIL) continue;
      if (el.closest('a')) continue;
      wrap(el, 'mailto:' + MAIL);
    }
  }

  function socials() {
    var host = document.querySelectorAll(
      '[data-pencil-name="Link — Instagram · TikTok · YouTube"]'
    );
    var i, j, k;
    var targets = [];

    for (i = 0; i < host.length; i++) targets.push(host[i]);

    /* запасной вариант — колонка бренда в подвале, если строки-заглушки нет.
       Проверяем, что в этом подвале иконок ещё нет: в редакторе тем секции
       перерисовываются и скрипт может отработать повторно. */
    if (!targets.length) {
      var col = document.querySelectorAll(
        '[data-pencil-name="Footer"] [data-pencil-name="Brand Column"],' +
        '[data-pencil-name="Footer"] [data-pencil-name="Brand Stack"]'
      );
      for (i = 0; i < col.length; i++) {
        var foot = col[i].closest('[data-pencil-name="Footer"]');
        if (foot && foot.querySelector('.pi-social')) continue;
        var ph = document.createElement('div');
        col[i].appendChild(ph);
        targets.push(ph);
      }
    }

    for (k = 0; k < targets.length; k++) {
      var t = targets[k];
      if (t.getAttribute('data-pi-social')) continue;
      var row = document.createElement('div');
      row.className = 'pi-social';
      row.setAttribute('data-pi-social', '1');
      var h = '';
      for (j = 0; j < SOCIAL.length; j++) {
        h += '<a href="' + SOCIAL[j][1] + '" target="_blank" rel="noopener"' +
             ' aria-label="' + SOCIAL[j][0] + '" title="' + SOCIAL[j][0] + '">' +
             '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
             '<path d="' + SOCIAL[j][2] + '"/></svg></a>';
      }
      row.innerHTML = h;
      if (t.parentNode) t.parentNode.replaceChild(row, t);
    }
  }

  /* Блок «The Shop»: карточки избранных товаров рендерит pi-mob-0 в <template>,
     здесь только вставляем их вместо заглушек экспорта — и в десктопном
     блоке, и в мобильном. Подборка задаётся коллекцией «featured». */

  /* Аккордеон «06 The Alternatives» на телефоне.

     Блок раньше прятали целиком — из-за длины. Прятать его нельзя: это
     единственное место, где цена переопределяется сравнением с daycare,
     дог-парком и выгульщиком, а телефон — основной трафик. Поэтому здесь
     он свёрнут в список: видны все четыре заголовка, раскрыта своя,
     четвёртая. Разметку не трогаем, всё держится на классе .pi-acc-open,
     стили — в pi-tune.css. Только мобильная вёрстка: на десктопе карточки
     стоят в ряд и раскрывать нечего. */
  function alternatives() {
    var cards = document.querySelectorAll('.pi-mobile [data-pencil-name^="Option \u2014 "]');
    if (!cards.length) return;

    function open(card, on) {
      card.classList.toggle('pi-acc-open', on);
      card.setAttribute('aria-expanded', on ? 'true' : 'false');
    }

    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.getAttribute('data-pi-acc')) continue;
      card.setAttribute('data-pi-acc', '1');
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');

      /* своя карточка открыта сразу — с неё и читают */
      var mine = (card.getAttribute('data-pencil-name') || '').indexOf('A day out of the city') !== -1;
      open(card, mine);

      card.addEventListener('click', function (e) {
        /* по кнопке внутри карточки уходим на анкету, а не схлопываем */
        if (e.target.closest && e.target.closest('a')) return;
        open(this, !this.classList.contains('pi-acc-open'));
      });
      card.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        if (e.target !== this) return;
        e.preventDefault();
        open(this, !this.classList.contains('pi-acc-open'));
      });
    }
  }

  function shopcards() {
    var tpl = document.getElementById('pi-shopcards');
    if (!tpl || !tpl.content.querySelector('a')) return;

    function mount(box, cls) {
      if (!box || box.querySelector('.pi-shopgrid')) return;
      /* что заменяем: слот, ряды-заглушки или контейнер Products */
      var slot = box.querySelector('[data-pi-mshop-slot]');
      var rows = [].slice.call(box.querySelectorAll('[data-pencil-name="Product Row"]'));
      var pack = box.querySelector('[data-pencil-name="Products"]');
      var anchor = slot || rows[0] || pack;
      if (!anchor) return;

      var grid = document.createElement('div');
      grid.className = 'pi-shopgrid ' + cls;
      grid.appendChild(tpl.content.cloneNode(true));
      anchor.parentNode.insertBefore(grid, anchor);

      if (pack && pack.parentNode) pack.parentNode.removeChild(pack);
      if (slot && slot.parentNode) slot.parentNode.removeChild(slot);
      for (var i = rows.length - 1; i >= 0; i--) {
        if (rows[i].parentNode) rows[i].parentNode.removeChild(rows[i]);
      }
    }

    mount(document.querySelector('.pi-exact [data-pencil-name="15 The Shop"]'), 'pi-shopgrid--d');
    mount(document.querySelector('.pi-mobile [data-pencil-name="15 The Shop"]'), 'pi-shopgrid--m');
  }

  /* Ширина окна без полосы прокрутки — для пропорционального масштаба холстов */

  function fit() {
    var w = document.documentElement.clientWidth || window.innerWidth;
    document.documentElement.style.setProperty('--pi-vw', w + 'px');
  }

  /* Витрина Shopify (коллекции, товар, корзина) — помечаем body для шкурки pi-shop.css */
  function store() {
    var m = document.querySelector('main[data-template]');
    if (!m) return;
    var t = m.getAttribute('data-template') || '';
    if (/^(collection|list-collections|product|search|cart|404)/.test(t)) {
      document.body.classList.add('pi-store');
    }
  }

  /* Якорь на блок «День» вместо снятой с публикации страницы /pages/the-day.
     Десктопный и мобильный холсты лежат в DOM одновременно, поэтому одинаковый
     id повесить нельзя: браузер нашёл бы первый попавшийся и на телефоне
     прокрутка уехала бы в скрытую десктопную вёрстку. Даём каждому свой id
     и переписываем ссылку внутри мобильного холста. */
  function dayAnchor() {
    var d = document.querySelector('.pi-exact [data-pencil-name="06 The Day Sheet"]');
    if (d) d.id = 'pi-day';
    var m = document.querySelector('.pi-mobile [data-pencil-name="06 The Day Sheet"]');
    if (m) {
      m.id = 'pi-day-m';
      var links = document.querySelectorAll('.pi-mobile a[href="#pi-day"]');
      for (var i = 0; i < links.length; i++) links[i].setAttribute('href', '#pi-day-m');
    }

    /* То же для карты зоны обслуживания. Страница /pages/service-area удалена:
       она повторяла этот раздел один в один, а её кнопка «Check your address»
       вела в анкету и адрес ничего не проверяла. Весь текст, которого здесь
       не хватало, перенесён сюда, ссылки ведут на якорь.
       Форма /#pi-area, а не #pi-area, — чтобы работало и с других страниц. */
    var a = document.querySelector('.pi-exact [data-pencil-name="14 Service Area"]');
    if (a) a.id = 'pi-area';
    var am = document.querySelector('.pi-mobile [data-pencil-name="14 Service Area"]');
    if (am) {
      am.id = 'pi-area-m';
      var al = document.querySelectorAll('.pi-mobile a[href="#pi-area"], .pi-mobile a[href="/#pi-area"]');
      for (var j = 0; j < al.length; j++) al[j].setAttribute('href', '#pi-area-m');
    }

    /* Города в зоне обслуживания ведут на свои страницы /pages/dog-hiking-<город>-nj
       (07.10.2026, слово Billionaire). Ловим листовые блоки, где текст ровно имя города:
       подписи списка и метки на карте, на десктопе и на телефоне. */
    var TOWNS = ['Hoboken','Jersey City','Weehawken','West New York','Edgewater','Cliffside Park',
                 'Fort Lee','Englewood Cliffs','Tenafly','Alpine'];
    [a, am].forEach(function (sec) {
      if (!sec) return;
      var els = sec.querySelectorAll('div, span');
      for (var k = 0; k < els.length; k++) {
        var el = els[k];
        if (el.children.length || el.closest('a')) continue;
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        for (var n = 0; n < TOWNS.length; n++) {
          if (t !== TOWNS[n].toLowerCase()) continue;
          var ln = document.createElement('a');
          ln.className = 'pi-mh pi-town';
          ln.href = '/pages/dog-hiking-' + TOWNS[n].toLowerCase().replace(/ /g, '-') + '-nj';
          ln.textContent = el.textContent.trim();
          el.textContent = '';
          el.appendChild(ln);
          break;
        }
      }
    });

    /* Тарифы и шаттл — для кнопок первого экрана. */
    [['13 Plans', 'pi-plans'], ['08 The Shuttle', 'pi-shuttle']].forEach(function (x) {
      var dsk = document.querySelector('.pi-exact [data-pencil-name="' + x[0] + '"]');
      if (dsk) dsk.id = x[1];
      var mob = document.querySelector('.pi-mobile [data-pencil-name="' + x[0] + '"]');
      if (mob) {
        mob.id = x[1] + '-m';
        var ml = document.querySelectorAll('.pi-mobile a[href="#' + x[1] + '"]');
        for (var k = 0; k < ml.length; k++) ml[k].setAttribute('href', '#' + x[1] + '-m');
      }
    });
  }

  /* КОРЗИНА В ШАПКЕ. В экспорте её нет вовсе, поэтому попасть в корзину было
     неоткуда: из чекаута Shopify удалять позиции не даёт по своему устройству,
     а ссылки на /cart на сайте не существовало — товар оставался висеть.

     Выдвижной ящик Dawn уже отрисован в theme.liquid и его скрипт загружен,
     не хватало только кнопки. Ставим её в «Header Right» — этот узел есть
     и в десктопной шапке, и в мобильной, и на внутренних страницах.

     Открываем ящик сами, а не через #cart-icon-bubble: оба холста лежат в DOM
     одновременно, Dawn нашёл бы первую попавшуюся кнопку — на телефоне ей
     оказалась бы скрытая десктопная, и клик не сработал бы. Если ящика нет,
     ссылка ведёт на /cart обычным переходом.

     Счётчик обновляем из /cart.js: шапку Dawn не перерисовывает, и после
     добавления товара число иначе осталось бы прежним до перезагрузки. */
  function cart() {
    var rights = document.querySelectorAll('[data-pencil-name="Header Right"]');
    if (!rights.length) return;

    var ICON = '<svg viewBox="0 0 22 22" aria-hidden="true" focusable="false">' +
      '<path d="M3 5h2.2l2.2 9.2h9.1l2.1-6.6H6.6" fill="none" stroke="currentColor" ' +
      'stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<circle cx="9.2" cy="18" r="1.5" fill="currentColor"/>' +
      '<circle cx="16.2" cy="18" r="1.5" fill="currentColor"/></svg>';

    for (var i = 0; i < rights.length; i++) {
      if (rights[i].querySelector('.pi-cart')) continue;
      var a = document.createElement('a');
      a.className = 'pi-cart';
      a.href = '/cart';
      a.setAttribute('aria-label', 'Cart');
      a.innerHTML = ICON + '<span class="pi-cart__n" hidden>0</span>';
      a.addEventListener('click', function (e) {
        var d = document.querySelector('cart-drawer');
        if (d && typeof d.open === 'function') { e.preventDefault(); d.open(this); }
      });
      rights[i].insertBefore(a, rights[i].firstChild);
    }

    function paint(n) {
      var b = document.querySelectorAll('.pi-cart__n');
      for (var k = 0; k < b.length; k++) {
        b[k].textContent = n > 99 ? '99+' : String(n);
        b[k].hidden = !n;
      }
    }
    function refresh() {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { paint(c.item_count || 0); })
        .catch(function () {});
    }
    refresh();

    /* ящик перерисовывается при каждом изменении корзины — ловим это
       и пересчитываем число, вместо того чтобы гадать, кто и когда добавил */
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      var t = null;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(refresh, 250);
      }).observe(drawer, { childList: true, subtree: true });
    }
  }

  function init() {
    try { fit(); } catch (e) {}
    try { store(); } catch (e) {}
    try { linkify(); } catch (e) {}
    try { dayAnchor(); } catch (e) {}
    try { cart(); } catch (e) {}
    try { scrubPhone(); } catch (e) {}
    try { mailLinks(); } catch (e) {}
    try { socials(); } catch (e) {}
    try { shopcards(); } catch (e) {}
    try { alternatives(); } catch (e) {}
    try { menu(); } catch (e) {}
  }

  try {
    fit();
    window.addEventListener('resize', fit, { passive: true });
    window.addEventListener('orientationchange', fit);
  } catch (e) {}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Ссылки на карту зоны обслуживания.

     На странице одновременно лежат десктопный и мобильный холсты, виден
     всегда только один. Переписать href при загрузке мало: бургер-меню
     живёт вне обоих холстов, а после поворота экрана правильная цель
     меняется. Поэтому раздел выбираем в момент клика — тот из двух,
     который сейчас на экране. */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href$="#pi-area"]') : null;
    if (!a) return;
    var vis = ['pi-area', 'pi-area-m']
      .map(function (id) { return document.getElementById(id); })
      .filter(function (el) { return el && el.getBoundingClientRect().width > 2; })[0];
    if (!vis) return;
    e.preventDefault();
    /* блоки главной ниже экрана не нарисованы (content-visibility в theme.liquid) —
       рисуем всё, иначе прокрутка промахнётся мимо раздела */
    document.documentElement.style.setProperty('--pi-cv', 'visible');
    vis.scrollIntoView({ behavior: 'smooth', block: 'start' });
    try { history.replaceState(null, '', '#' + vis.id); } catch (err) {}
  }, true);

})();
